<ndt-compact-register-view
   [name]="name"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [pagingCallState]="pagingCallState"
   [showCreate]="showCreate"
   [hideHeader]="hideHeader"
   (create)="onCreate()"
   (loadMore)="onLoadMore()"
>
   <div class="flex-container">
      <ndt-register-create-options class="create-button ml-auto">
         @if (canEdit) {
         <button
            type="button"
            mat-raised-button
            color="primary"
            [matMenuTriggerFor]="createPhoneMenu"
            matTooltip="Create Phone"
            id="create-phone-button"
            >Add Phone
         </button>
         }
         <mat-menu #createPhoneMenu="matMenu">
            @for (createPhoneTypeOption of createPhoneTypeOptions; track createPhoneTypeOption) {
            <button mat-menu-item (click)="onCreatePhoneTypeSelected(createPhoneTypeOption)">
               {{ createPhoneTypeOption.name }}
            </button>
            }
         </mat-menu>
      </ndt-register-create-options>
   </div>
   <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource">
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <tr lcs-row *lcsResponsiveRowDef></tr>
         <ng-container lcsColumnDef="phoneType" width="3">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="active-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Asc"
               sortField="phoneTypeName"
               >Phone Type<mat-icon class="mat-icon-sort">{{ getSort('phoneTypeName') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let phone" class="phone-issues-chip-and-menu">
               <button class="table-button" type="button" (click)="onRowClick(phone)">
                  {{ phone.phoneType }}
               </button>
               @if (phone.hasIssue === true) {
               <phone-issues-chip-and-menu
                  [hackedFraudDetails]="hackedFraudDetails"
                  [onlyDisplayInstructions]="true"
                  [phone]="phone"
               ></phone-issues-chip-and-menu>
               }
            </td>
         </ng-container>
         <ng-container lcsColumnDef="name" width="3.5">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="phoneid-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="displayName"
               >Name<mat-icon class="mat-icon-sort">{{ getSort('displayName') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let phone">
               <button class="table-button" type="button" (click)="onRowClick(phone)">
                  {{ phone.name }}
                  @if (invalidPhoneIds.includes(phone.phoneId)) {
                  <mat-error class="phone-mat-error"> * Duplicate </mat-error>
                  }
               </button>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="sipUser" width="4">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="phoneid-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="sipUsername"
            >
               Sip Username
               <mat-icon class="mat-icon-sort">{{ getSort('sipUsername') }}</mat-icon>
            </th>
            <td lcs-cell *lcsCellDef="let phone">
               <button class="table-button" type="button" (click)="onRowClick(phone)">
                  <div class="icon-text-wrapper">
                     <mat-icon
                        class="small-icon"
                        (click)="copySipUsernameToClipboard(phone); $event.preventDefault(); $event.stopPropagation()"
                        >content_copy</mat-icon
                     >
                     <span class="sip-text" spanTitleIfOverflow>{{ phone.sipUsers?.[0]?.userName }}</span>
                  </div>
               </button>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="isConnected" width="2">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="domain-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="sipUsers.isConnected"
               >Status <mat-icon class="mat-icon-sort">{{ getSort('sipUsers.isConnected') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let phone">
               <button class="table-button" type="button" (click)="onRowClick(phone)">
                  @if (phone.sipUsers?.[0]?.isConnected) {
                  <div [style.color]="'green'">Connected</div>
                  } @else { Disconnected }
               </button>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="numberOfLineKeys" width="1.5">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="numberOfLineKeys-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="numberOfLineKeys"
               >Lines<mat-icon class="mat-icon-sort">{{ getSort('numberOfLineKeys') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let phone">
               <button class="table-button" type="button" (click)="onRowClick(phone)">
                  {{ phone.phoneType == 'Hardphone' ? phone.numberOfLineKeys : '-' }}
               </button>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="phoneActionsMenu" width="1">
            <th lcs-header-cell *lcsHeaderCellDef id="phone-actions-menu-column-header"></th>
            <td lcs-cell *lcsCellDef="let phone">
               <button
                  mat-icon-button
                  [matMenuTriggerFor]="dataMenu"
                  [matMenuTriggerData]="{ phone: phone }"
                  class="data-menu-button"
                  type="button"
               >
                  <mat-icon>more_horiz</mat-icon>
               </button>
               <mat-menu #dataMenu="matMenu">
                  <ng-template matMenuContent let-phone="phone">
                     @if (canEdit && phone.phoneType !== phoneTypes.Appsuite) {
                     <button type="button" mat-menu-item (click)="onEditClick(phone)"> Edit </button>
                     } @if (phone.phoneType === phoneTypes.Hardphone) {
                     <button type="button" mat-menu-item (click)="copyMacAddressToClipboard(phone)">
                        Copy MAC Address
                     </button>
                     }
                     <button type="button" mat-menu-item (click)="copySipUsernameToClipboard(phone)">
                        Copy Sip Username
                     </button>
                     @if ((phone.phoneType === phoneTypes.Hardphone || phone.phoneType === phoneTypes.Handset) &&
                     (phone?.sipUsers?.[0]?.internalIps || phone?.sipUsers?.[0]?.externalIps || phone?.adminPassword)) {
                     <button mat-menu-item [matMenuTriggerFor]="webInterfaceMenu"> Web Interface </button>
                     } @if (phone.phoneType === phoneTypes.Hardphone && isSystemUser) {
                     <button type="button" mat-menu-item (click)="rebootPhoneClick(phone)"> Reboot Phone </button>
                     } @if ( phone.phoneType === phoneTypes.Hardphone && phone.devices[0]?.ztStatus === true &&
                     isSystemUser ) {
                     <button type="button" mat-menu-item (click)="resetPhoneZtpClick(phone)">
                        Factory Reset Phone
                     </button>
                     } @if (phone.hasIssue === true) {
                     <button
                        mat-menu-item
                        type="button"
                        id="resolve-issue-button"
                        (click)="resetHackedAndFraudDetails(phone)"
                     >
                        Resolve issue
                     </button>
                     } @if (phone.phoneType === phoneTypes.Hardphone && canReleaseToAccount(phone.devices[0])) {
                     <button mat-menu-item [matMenuTriggerFor]="releaseMenu"> Release / Remove </button>
                     } @if (canDelete && phone.phoneType !== phoneTypes.Hardphone) {
                     <button type="button" mat-menu-item (click)="onDeleteClick(phone)"> Delete </button>
                     }
                     <mat-menu #webInterfaceMenu="matMenu">
                        @if ((phone.phoneType === phoneTypes.Hardphone || phone.phoneType === phoneTypes.Handset) &&
                        (phone?.sipUsers?.[0]?.internalIps || phone?.sipUsers?.[0]?.externalIps)) {
                        <button mat-menu-item (click)="copyWebInterfaceUrl(phone)"> Copy Web Interface URL </button>
                        }
                        <button mat-menu-item (click)="copyCurrentWebInterfacePassword(phone)">
                           Copy Current Password
                        </button>
                     </mat-menu>
                     <mat-menu #releaseMenu="matMenu">
                        <button
                           mat-menu-item
                           type="button"
                           (click)="
                              onReleaseToAccountClick(phone.devices[0]);
                              $event.preventDefault();
                              $event.stopPropagation()
                           "
                           id="device-release-to-account"
                        >
                           Release to Account
                        </button>
                        <button
                           mat-menu-item
                           type="button"
                           (click)="
                              onReleaseToSystemClick(phone.devices[0]);
                              $event.preventDefault();
                              $event.stopPropagation()
                           "
                           id="device-release-to-system"
                        >
                           Release to System
                        </button>
                        <button
                           mat-menu-item
                           type="button"
                           (click)="
                              onDeleteFromSystemClick(phone.devices[0]);
                              $event.preventDefault();
                              $event.stopPropagation()
                           "
                           id="device-delete"
                        >
                           Remove from System
                        </button>
                     </mat-menu>
                  </ng-template>
               </mat-menu>
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
</ndt-compact-register-view>
